import { combineReducers } from 'redux';
import apartmentReducer from './apartmentReducer';
import formReducer from './formReducer';
export default combineReducers({
    apartmentReducer,
    formReducer,
})
